<template>
  <div id="crew-dm-select-box">
    <div>
      <label class="block aisea-text-14-600-black mb-2"
        >{{ label }} <span v-if="required" style="color: red;">*</span></label
      >
      <treeselect
        v-model="selectedData"
        :appendToBody="true"
        :multiple="isMultiple"
        :searchable="false"
        :clearable="false"
        :required="this.required"
        :options="optionsListWithSelectAll"
        :defaultOptions="true"
        :placeholder="this.placeholder"
        :valueFormat="optionsType === 'fiscalYear' ? 'id' : 'object'"
        :defaultExpandLevel="1"
        :limit="1"
        :limitText="count => `+${count}`"
        noOptionsText="なし"
        @input="onChange"
        class="aisea-text-16-400-black"
      />
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { createNamespacedHelpers } from "vuex";

// Store
const { mapGetters: mapGettersOfCrewDataManagement } = createNamespacedHelpers(
  "crewDataManagement"
);

export default {
  props: {
    id: { type: String, required: true },
    label: { type: String, default: "" },
    required: Boolean,
    placeholder: { type: String, default: "選択してください..." },
    optionsType: { type: String, default: null },
    options: { type: [Array, Object], default: () => [] },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    isMultiple: { type: Boolean, default: false },
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      selectedData: this.value,
      optionsList: [],
    };
  },
  watch: {
    value(newValue) {
      this.selectedData = newValue;
    },
  },
  created() {
    this.initializeOptions();
  },
  computed: {
    optionsListWithSelectAll() {
      if (this.isMultiple) {
        return [{ id: "all", label: "全て", children: this.optionsList }];
      }
      return this.optionsList;
    },
  },
  methods: {
    ...mapGettersOfCrewDataManagement([
      "getManningVesselsOptions",
      "getEnterpriseCrews",
    ]),

    async initializeOptions() {
      if (this.optionsType === "manningVessels") {
        this.optionsList = this.getManningVesselsOptions();
      } else if (this.optionsType === "fiscalYear") {
        this.optionsList = this.getFiscalYearOptions();
      } else if (this.optionsType === "enterpriseCrews") {
        this.optionsList = this.getEnterpriseCrews();
      } else {
        this.optionsList = this.options;
      }
    },

    getFiscalYearOptions() {
      // 今年から6年前までの年を取得
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 6;
      const options = [];
      for (let year = startYear; year <= currentYear; year++) {
        options.push({ id: year, label: year });
      }
      return options.reverse();
    },

    onChange(value) {
      this.$emit("input", { id: this.id, value });
    },
  },
};
</script>
<style lang="scss">
@import "src/assets/scss/aisea/variables";

#crew-dm-select-box {
  .vue-treeselect__control {
    border: 1px solid #ccc !important;
  }

  .vue-treeselect__placeholder {
    color: #757575 !important;
  }

  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }
}
</style>